import { Badge, Flex, Heading, Text } from "@aws-amplify/ui-react";
import * as React from "react";
import RaisedButton from "../../../components/RaisedButton";
import { referAFriendModalOptions } from "../../../util/modals/referAFriendModalOptions";
import useModal from "../../../hooks/useModal";
import { FaArrowCircleRight } from "react-icons/fa";

export interface IOutOfTokensAlertProps {
  onComplete?: () => void;
}

export function OutOfTokensAlert(props: IOutOfTokensAlertProps) {
  const { onComplete } = props;

  // const navigate = useNavigate();

  const [ReferralModal, setReferralModal] = useModal(
    referAFriendModalOptions({ onHide: () => onComplete?.() }),
    []
  );

  return (
    <>
      <ReferralModal />
      <Flex direction={"column"}>
        <Text fontSize={{ base: "smaller", medium: "medium" }}>
          Don't worry. Tokens reset the first of each month! Here's 2 more ways
          to continue the fun:
        </Text>
        <Flex alignItems={"center"}>
          <Text
            fontWeight={"bold"}
            fontSize={{ base: "smaller", medium: "medium" }}
          >
            <Badge marginRight={"xxxs"}>1</Badge> Upgrade to Premium 👑
          </Text>

          <RaisedButton
            size="small"
            backgroundColor={"#47a6ff"}
            onClick={() => {
              window.open("/dashboard/upgrade", "_blank");
              onComplete?.();
            }}
          >
            <FaArrowCircleRight />
          </RaisedButton>
        </Flex>
        <Text fontSize={{ base: "smaller", medium: "medium" }}>
          <ul>
            <li>
              Get unlimited text generation tokens and unlock endless quiz and
              lesson generations.{" "}
            </li>
          </ul>
        </Text>
        <Flex alignItems={"center"}>
          <Text
            fontWeight={"bold"}
            fontSize={{ base: "smaller", medium: "medium" }}
          >
            <Badge marginRight={"xxxs"}>2</Badge> Refer & Win Together 👫{" "}
          </Text>

          <RaisedButton
            size="small"
            backgroundColor={"#47a6ff"}
            onClick={() => {
              setReferralModal(true);
            }}
          >
            <FaArrowCircleRight />
          </RaisedButton>
        </Flex>
        <Text fontSize={{ base: "smaller", medium: "medium" }}>
          <ul>
            <li>Share your unique referral code with friends.</li>
            <li>
              Each friend who joins gets you 10,000 tokens - and they get 10,000
              too!
            </li>
            <li>
              Bonus: After 5 referrals, grab a{" "}
              <i>1-Month Free Trial of Premium</i>! 🎉
            </li>
          </ul>
        </Text>

        <Heading
          fontSize={{ base: "smaller", medium: "medium" }}
          alignSelf={"center"}
        >
          🧡 Start now and keep the fun going! 🧡
        </Heading>
        {/* <Flex width={"100%"}></Flex> */}
      </Flex>
    </>
  );
}
